import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { NgTable } from '../../coms';
import { AuthService } from '../../services/auth.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { NewPrompterReportService, NewPrompterReport } from '../../services/new-prompter-report.service';
import { ProductionOrderId, ProductionOrderService } from '../../services/production-order.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-create-new-prompter-report',
  templateUrl: './create-new-prompter-report.component.html',
  styleUrls: ['./create-new-prompter-report.component.css']
})
export class CreateNewPrompterReportComponent implements OnInit, OnDestroy {

  subs: Subscription[] = [];

  form: FormGroup;

  pickadateParams = Utils.pickadateParams();
  pickatimeParams = Utils.pickatimeParams();

  constructor(
    private service: NewPrompterReportService,
    private employeeService: EmployeeService,
    private odpService: ProductionOrderService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
  ) {
    this.subs[0] = this.employeeService.getEmployees().subscribe(employees => {
      this.employees = {};
      this.rowsRead[0] = employees.map(employee => {
        employee.id = employee.id$;
        employee.name = `${employee.name} ${employee.lastName}`;
        this.employees[employee.id] = employee;
        return employee;
      });
    });

    this.subs[1] = this.odpService.getProductionOrders().subscribe(odps => {
      this.odps = {};
      this.rowsRead[1] = odps.map(odp => {
        this.odps[odp.id] = odp;
        return odp;
      });
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let newPrompterReport: NewPrompterReport = {
      employeeId: this.selectedIds[0],
      employeeName: this.employees[this.selectedIds[0]].name,
      odpId: this.selectedIds[1],
      odpName: this.odps[this.selectedIds[1]].name,
      date: value.date,
      time: value.time,
      employees: [],
      userEmail: this.authService.currentUser.email,
    };

    let docRef = await this.service.addNewPrompterReport(newPrompterReport);
    this.service.windowReplace.edit(docRef.id);
  }
  onCancel(){
    this.service.windowReplace.read();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  readTables: NgTable[] = [];
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    console.log(index);
    this.currentReadIndex = index;
    this.readTables[index] = new NgTable({columns: this.columnsRead[index], data: this.rowsRead[index], itemsPerPage: 5, onCellClick: this.selectRead.bind(this)});
  
    //this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
  }
  unselectRead(){
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = '';
  }

  selectedIds: string[] = [''];
  employees: {[id: string]: EmployeeId} = {};
  odps: {[id: string]: ProductionOrderId} = {};

  get readValid(){ return !!this.employees[this.selectedIds[0]] && !!this.odps[this.selectedIds[1]] };
  currentReadIndex: number;
  rowsRead = [[], []];
  columnsRead = [
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//odp
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
  ];

}
